import XHeader from 'vux/src/components/x-header/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'

export default {
name: 'orderDetail',
directives: {
TransferDom
},
components: {
XHeader,
CheckIcon,
Group,
XButton,
Icon,
Timeline,
TimelineItem,
Confirm,
Actionsheet,
Popup,
Datetime,
},
data () {
return {
OrderStatusLogList: [],   //订单状态列表
invoiceData: {},    //发票信息
orderInfo: {},    //订单信息
ExpressTrackData: {}, //物流信息
totalQty: 0,   //商品数量
showConfirm: false,
confirmText: '',
cancelText: '',
confirmImg: '',
confirmContent: '',
confirmEvent: '',
showSupplementalInvoice: false,
supplementalInvoiceMenus: {
single: '补开此订单发票',
withOthers: '和其它订单一起补开发票',
},
showInvoiceOrderList: false,
invoiceOrderList: [],
startTime: '',
endTime: '',
invoiceOrderNum: '',
selectedItem: '',
showConfirmReceipt: false,
reason: []
}
},
methods: {
getOrderStatusLog () {  //获取状态列表
this.$request.post('/order/getOrderStatusLog',{
orderId: this.$route.query.orderId,
token: this.$token,
}).then(data => {
if(data.code == 0){
this.OrderStatusLogList = [...data.obj]
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
getInvoice () {   //获取发票
this.$request.post('/invoice/getBasicByOrderId',{
orderId: this.$route.query.orderId,
token: this.$token,
}).then(data => {
if(data.code == 0){
if(data.obj.invoiceType) {
this.invoiceData = {...data.obj}
}

}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
getOrderInfo () {   //获取订单信息
this.$request.post('/order/getOrderById',{
orderId: this.$route.query.orderId,
token: this.$token,
}).then(data => {
if(data.code == 0){
this.orderInfo = {...data.obj}
if(!this.orderInfo.expressAmt){
this.orderInfo.expressAmt = 0
}
this.reason = []
for(let i=0; i<data.obj.transferAccountsMsg.split('_@_').length; i++){
if(i < data.obj.transferAccountsMsg.split('_@_').length-1){
this.reason.push(data.obj.transferAccountsMsg.split('_@_')[i])
}
}


this.getExpressTrack(data.obj.expressActualCode,data.obj.expressNumber,data.obj.phone)
this.orderInfo.listOrderDetail.forEach((item, index) => {
this.totalQty += Number(item.qty)
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {




console.log(e)
})
},
getExpressTrack (expressActualCode,expressNumber,phone) {  //获取物流信息




this.$request.post('/order/getExpressTrack',{
expressActualCode,
expressNumber,
phone:phone,
token: this.$token,
}).then(data => {
if(data.code == 0){
this.ExpressTrackData = {...data.obj}
console.log(JSON.parse(JSON.stringify(this.ExpressTrackData)))
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})




},
payNow () {    //立即付款
if(this.orderInfo.orderType == "商城"){
for(let i=0; i<this.orderInfo.listOrderDetail.length; i++){
if(this.orderInfo.listOrderDetail[i].soldStatus != '上架'){
this.$vux.toast.show({
type: 'warn',
text: this.orderInfo.listOrderDetail[i].spuName+' 已下架'
})
return false;
}
}
}
this.$router.push({
path: '/submitOrderSuccess',
query: {
orderNumber: this.orderInfo.orderUnionCode ? this.orderInfo.orderUnionCode : this.orderInfo.orderCode
}
})
},
buyAgain () {  //再次购买
if(this.orderInfo.orderType == "商城"){
for(let i=0; i<this.orderInfo.listOrderDetail.length; i++){
if(this.orderInfo.listOrderDetail[i].soldStatus != '上架'){
this.$vux.toast.show({
type: 'warn',
text: this.orderInfo.listOrderDetail[i].spuName+' 已下架'
})
return false;
}
}
}
this.$request.post('/order/buyagain',{
orderId: this.$route.query.orderId,
token: this.$token,
}).then(data => {
if(data.code == 0){
this.$router.push({
path: '/submitOrderSuccess',
query: {
orderNumber: this.orderInfo.orderUnionCode ? this.orderInfo.orderUnionCode : this.orderInfo.orderCode
}
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
cancelOrder () {   //取消订单
this.showConfirm = true
this.confirmEvent = 'cancelOrder'
this.confirmText = '确定'
this.cancelText = '再想想'
this.confirmImg = require('../../assets/images/redWarn.png')
this.confirmContent = '确定取消该订单吗？'
},
applicationForDrawback () {   //申请退款
this.showConfirm = true
this.confirmEvent = 'applicationForDrawback'
this.confirmText = '确定'
this.cancelText = '再想想'
this.confirmImg = require('../../assets/images/redWarn.png')
this.confirmContent = '确定申请退款吗？'
},
confirmReceipt () {   //确认收货
this.$request.post('/order/confirmReceive',{
orderId: this.$route.query.orderId,
token: this.$token,
}).then(data => {
this.showConfirmReceipt = false
if(data.code == 0){
this.showConfirm = true
this.confirmEvent = 'confirmReceipt'
this.confirmText = '立即评价'
this.cancelText = '确定'
this.confirmImg = require('../../assets/images/blueSuccess.png')
this.confirmContent = '确认收货成功'
this.orderInfo.orderStatus = '500'
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
evaluate () {    //评价
if(this.orderInfo.orderType == '商城'){
this.$router.push({
path: '/evaluate',
query: {
orderId: this.$route.query.orderId
}
})
}else{
this.$vux.toast.show({
type: 'warn',
text: '非商城商品，不可评价'
})
}
},



onConfirm () {
if(this.confirmEvent == 'cancelOrder'){   //确定取消订单
this.$request.post('/order/cancelOrder',{
orderId: this.$route.query.orderId,
token: this.$token,
}).then(data => {
if(data.code == 0){
this.$vux.toast.show({
type: 'success',
text: '订单已取消'
})
this.orderInfo.orderStatus = '100'
this.getOrderStatusLog()





}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}else if(this.confirmEvent == 'applicationForDrawback'){   //确定申请退款
this.$request.post('/order/applyRefund',{
orderId: this.$route.query.orderId,
token: this.$token,
}).then(data => {
if(data.code == 0){
this.$vux.toast.show({
type: 'success',
text: '已申请退款'
})
this.orderInfo.orderStatus = '200'
setTimeout(() => {
this.$router.push({
path: '/myOrder'
})
}, 1000);
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}else if(this.confirmEvent == 'confirmReceipt'){   //立即评价

if(this.orderInfo.orderType != '商城'){
this.$vux.toast.show({
type: 'warn',
text: '该类型订单不支持评价'
})
}else{
this.$router.push({
path: '/evaluate',
query: {
orderId: this.$route.query.orderId
}
})
}
}
},
onCancel () {
console.log('取消')
if(this.confirmEvent == 'confirmReceipt'){

}
},
getInvoiceOrders () {
this.$request.post('/order/listOrderBasicByPatch',{
startTime: this.startTime,
endTime: this.endTime,
searchContent: this.invoiceOrderNum
}).then(data => {
console.log(this.selectedItem)
if(data.code == 0){
data.obj.forEach((item, index) => {
item.selected = false
item.showDetail = false
})
this.invoiceOrderList = data.obj.filter((item, index) => {
return item.orderCode != this.selectedItem.orderCode
})

}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
supplementalInvoice (item, index) {
this.showSupplementalInvoice = true
this.selectedItem = item
console.log(JSON.parse(JSON.stringify(item)))
},
selectedInvoiceType (key) {
console.log(key)
if(key == 'withOthers'){
this.startTime = ''
this.endTime = ''
this.invoiceOrderNum = ''
this.showInvoiceOrderList = true
this.getInvoiceOrders()
}else if(key == 'single'){
this.$router.push({
path: '/supplementalInvoice',
query: {
ordreCode: this.$route.query.orderCode
}
})
}
},
closeInvoiceOrderDialog () {
this.showSupplementalInvoice = true
this.showInvoiceOrderList = false
},
selectedInvoiceOrderList () {

let str = ''
this.invoiceOrderList.forEach((item, index) => {
if(item.selected){
str += item.orderCode+','
}
})
str += this.$route.query.orderCode
str=(str.substring(str.length-1)==',')?str.substring(0,str.length-1):str
this.$router.push({
path: '/supplementalInvoice',
query: {
ordreCode: str
}
})

console.log(str)
},
getInvoiceOrdersDetail (id,item) {
this.$request.post('/order/listOrderDetailByOrderId',{
orderId: id,
}).then(data => {
if(data.code == 0){
item.invoiceOrderDetailDatas = data.obj
item.showDetail = true
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
invoiceOrderDetail (item, index) {
console.log(JSON.parse(JSON.stringify(item)))
if(item.showDetail){
item.showDetail = !item.showDetail
}else{
this.getInvoiceOrdersDetail(item.id,index)
}
},
clearStartTime () {
this.startTime = ''
},
clearEndTime () {
this.endTime = ''
},
searchInvoiceOrder () {
this.getInvoiceOrders()
},
},
created () {
this.getOrderStatusLog()
this.getInvoice()
this.getOrderInfo()
}
}



// WEBPACK FOOTER //
// ./src/views/orderDetail/script.js